/* ===== Main Layout Shell ===== */

import { useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Navbar } from './Navbar'
import { useApp } from '@/presentation/providers/useApp'
import { useIdleLogout } from '@/presentation/hooks/useIdleLogout'

export function MainLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const { isLoading, user } = useApp()
  useIdleLogout()

  if (!isLoading && !user) {
    return <Navigate to="/login" replace />
  }

  return (
    <div className="app-shell flex min-h-screen flex-col text-neutral-900 dark:text-neutral-100 lg:flex-row">
      <Sidebar isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />

      <div className="flex min-w-0 flex-1 flex-col lg:ml-[270px]">
        <Navbar onOpenMobileMenu={() => setMobileMenuOpen(true)} />

        <main className="relative mx-auto w-full max-w-[1440px] flex-1 p-4 animate-fade-in md:p-6 lg:p-7">
          {isLoading && (
            <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/70 backdrop-blur-md dark:bg-neutral-950/80">
              <div className="flex items-center gap-3 rounded-[18px] border border-neutral-200 bg-white px-6 py-3.5 shadow-card-elevated dark:border-neutral-800 dark:bg-neutral-900">
                <svg className="h-5 w-5 animate-spin text-primary-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
                <span className="text-sm font-semibold text-neutral-700 dark:text-neutral-200">Cargando datos de organizacion...</span>
              </div>
            </div>
          )}
          <Outlet />
        </main>
      </div>
    </div>
  )
}
